import * as Icons from "@nova/component-icons"

export const getBatteryIcon = ({
    percentage,
    isCharging,
}: {
    percentage: number | null
    isCharging?: boolean
}) => {
    if (isCharging) return Icons.BatteryCharging20
    if (percentage === null) return Icons.BatteryUnknown
    if (percentage > 99) return Icons.BatteryFull
    if (percentage > 85) return Icons.Battery6Bar
    if (percentage > 70) return Icons.Battery5Bar
    if (percentage > 50) return Icons.Battery4Bar
    if (percentage > 35) return Icons.Battery3Bar
    if (percentage > 20) return Icons.Battery2Bar
    if (percentage > 5) return Icons.Battery1Bar
    if (percentage > 0) return Icons.Battery0Bar
    return Icons.BatteryAlert
}
